import config from '../../../config';
import services from '../../../services';
import util from '../../../util';
import { routeWithParams } from './helpers.js'

const { UserService } = services;
const { router } = util;

const {
    offersSelected,
    offersSelectedEmailInUse,
    offersSelectedRocketAccount,
    offersSelectedRocketAccountNeedsTrueUp,
    offersSelectedRocketAccountNeedsMerge,
    offersSelectedRocketAccountNeedsLogin,
    offersSelectedNeedsTrueUp,
    offersGenerated,
    adverseAction,
    blockingClientInProgress,
    blockingClientInProgressRocketAccount,
    registrationSuccess,
    blockingClientIneligible,
    blockingClientIneligibleRocketAccount,
    leadCompleteSuccess,
    leadCompleteSuccessEmailInUse,
    leadCompleteSuccessNeedsMerge,
    leadCompleteSuccessNeedsLogin,
    leadNeedsOfferSelect,
    raRegistrationReady,
    raRegistrationReadyNeedsLogin,
    raRegistrationReadyNeedsMerge
} = config.global.api.responseCodes.successCodes;
const {
    accountSuspended,
    accountSuspendedFraud,
    blockingClientOnRegistration,
    creditNoHitFreeze,
    creditNoHitFreezeTu,
    creditNoHitFreezeEqTu,
    identity,
    identityUnrecoverable,
    jwtUnauthorized,
    registeredAccountExists,
    registeredAccountExistsRocketAccount,
    emailInUseAlready,
    creditModelFailure,
    routedApplicationNotFound,
} = config.global.api.responseCodes.errorCodes;

export const mapping = {
    [creditModelFailure.code]: 'contact-us',
    [accountSuspended.code]: 'contact-us',
    [accountSuspendedFraud.code]: 'cannot-process',
    [creditNoHitFreeze.code]: () => routeWithParams(router,'credit-freeze-eq',['id', 'iat']),
    [creditNoHitFreezeTu.code]: () => routeWithParams(router,'credit-freeze-tu', ['id', 'iat']),
    [creditNoHitFreezeEqTu.code]: () => routeWithParams(router,'credit-freeze', ['id', 'iat']),
    [offersGenerated.code]: () => routeWithParams(router,'offers', ['id', 'iat']),
    [identity.code]: 'pii',
    [jwtUnauthorized.code]: '?expired=true',
    [offersSelectedNeedsTrueUp.code]: 'leadregister',
    [offersSelected.code]: (code, history) => {
        if (UserService.get('hasBlockingAccount')) {
            router.route(
                'reconcile?forceLogout=true&accountExists=true',
                config.webUIUrl
            );
        } else {
            history.push('register');
        }
    },
    [leadCompleteSuccess.code]: () => {
        const { firstName, lastName, email } = UserService.get() || {};
        RLAuth.signup(email, firstName, lastName);
    },
    [leadCompleteSuccessEmailInUse.code]: 'emailinuse',
    [leadCompleteSuccessNeedsMerge.code]: () => {
        router.route('', config.rocketAccountMergeAccountUrl);
    },
    [leadCompleteSuccessNeedsLogin.code]: () => {
        router.route('', config.rocketAccountLoginUrl);
    },
    [leadNeedsOfferSelect.code]: 'offers',
    [offersSelectedEmailInUse.code]: 'emailinuse',
    [offersSelectedRocketAccountNeedsTrueUp.code]: 'leadcomplete',
    [offersSelectedRocketAccount.code]: () => {
        const { firstName, lastName, email } = UserService.get() || {};
        RLAuth.signup(email, firstName, lastName);
    },
    [offersSelectedRocketAccountNeedsMerge.code]: () => {
        router.route('', config.rocketAccountMergeAccountUrl);
    },
    [offersSelectedRocketAccountNeedsLogin.code]: () => {
        router.route('', config.rocketAccountLoginUrl);
    },
    [raRegistrationReady.code]: () => {
        const { firstName, lastName, email } = UserService.get() || {};
        RLAuth.signup(email, firstName, lastName);
    },
    [raRegistrationReadyNeedsMerge.code]: () => {
        const { firstName, lastName, updatedEmail, email } = UserService.get() || {};
        RLAuth.signup(updatedEmail || email, firstName, lastName);
    },
    [raRegistrationReadyNeedsLogin.code]: () => {
        RLAuth.login();
    },
    [blockingClientOnRegistration.code]: () => {
        router.route(
            'reconcile?forceLogout=true&accountExists=true',
            config.webUIUrl
        );
    },
    [identityUnrecoverable.code]: () => {
        router.route('no-loan', config.webUIUrl);
    },
    [adverseAction.code]: () => {
        router.route('no-loan', config.webUIUrl);
    },
    [blockingClientInProgress.code]: () => {
        router.route('login?accountExists=true', config.webUIUrl);
    },
    [blockingClientInProgressRocketAccount.code]: 'account-exists',
    [blockingClientIneligible.code]: () => {
        router.route('login?accountExists=true', config.webUIUrl);
    },
    [blockingClientIneligibleRocketAccount.code]: 'account-exists',
    [registeredAccountExists.code]: () => {
        router.route('login?accountExists=true', config.webUIUrl);
    },
    [registeredAccountExistsRocketAccount.code]: () => {
        router.route('', config.rocketAccountRegisteredAccountExistsUrl);
    },
    [registrationSuccess.code]: () => {
        router.route('verify/bank-login/pcw', config.webUIUrl);
    },
    [emailInUseAlready.code]: 'emailinuse',
    [routedApplicationNotFound.code]: 'contact-us',
};

export const errorRoute = 'contact-us';
